import { ArrowUpRight } from "lucide-react";

export const STUDIO_URL = "https://skinloversstudio.com/";

export const StudioBanner = () => (
  <a href={STUDIO_URL} target="_blank" rel="noopener noreferrer" data-testid="studio-banner"
    className="group mt-14 sm:mt-20 relative block overflow-hidden rounded-3xl border border-gold/30 min-h-[340px] sm:min-h-[380px] animate-fade-up shadow-[0_30px_80px_-30px_rgba(212,175,55,0.35)]">
    <img src="/images/studio.jpg" alt="Skin Lovers Studio" loading="lazy"
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-noir via-noir/75 to-noir/45 sm:bg-gradient-to-r sm:from-noir sm:via-noir/75 sm:to-transparent" />
    <div className="relative h-full min-h-[340px] sm:min-h-[380px] flex flex-col justify-end sm:justify-center p-6 sm:p-12 max-w-xl">
      <p className="eyebrow">Skin Lovers Studio</p>
      <h2 className="text-3xl sm:text-5xl font-light leading-[1.05] mt-4">Ogni pelle racconta una storia.<br /><em className="text-gold-gradient">Impara ad ascoltarla.</em></h2>
      <p className="mt-4 text-sm text-white/80 leading-relaxed max-w-md">La tecnologia che valorizza il tuo tocco: analisi di pelle e corpo, referti col tuo brand e la storia di ogni cliente, in un'unica app.</p>
      <span className="btn-gold mt-7 self-start">Scopri Studio <ArrowUpRight className="w-4 h-4" /></span>
    </div>
  </a>
);
